import { RecentCampsite } from './types'

export class RecentCampsiteRepositoryLocalStorage {
  private localStorageKey = 'recentCampsites'
  private maxStorageEntries = 20

  add(id: string): void {
    try {
      const newEntry = {
        id,
        visitDate: new Date().toISOString(),
      }
      const storageRawData = localStorage.getItem(this.localStorageKey) || ''

      let data: Entry[]
      if (!storageRawData) {
        data = [newEntry]
      } else {
        const existingData = JSON.parse(storageRawData) as Entry[]
        data = existingData.filter((entry) => entry.id !== id)
        data.unshift(newEntry)
      }

      const finalData = data.slice(0, this.maxStorageEntries)
      localStorage.setItem(this.localStorageKey, JSON.stringify(finalData))
    } catch (error) {
      // eslint-disable-next-line no-console -- Sentry breadcrumb for debugging
      console.warn('[RecentCampsites] Failed to add recent campsite:', {
        id,
        error: error instanceof Error ? error.message : String(error),
      })
      // Clear corrupted data and start fresh
      try {
        localStorage.removeItem(this.localStorageKey)
      } catch {
        // Ignore
      }
    }
  }

  getAll(_langCode: string, limit?: number): RecentCampsite[] {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment -- JSON.parse returns unknown, cast is intentional
      const data: Entry[] = JSON.parse(
        localStorage.getItem(this.localStorageKey) || '[]',
      )
      return data.slice(0, limit)
    } catch (error) {
      // eslint-disable-next-line no-console -- Sentry breadcrumb for debugging
      console.warn('[RecentCampsites] Failed to get recent campsites:', {
        error: error instanceof Error ? error.message : String(error),
      })
      // Clear corrupted data
      try {
        localStorage.removeItem(this.localStorageKey)
      } catch {
        // Ignore
      }
      return []
    }
  }
}

interface Entry {
  id: string
  visitDate: string
}
